import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import MetricNumber from '../../../common/metric-number';

const Tile = styled.div`
  width: 120px;
  display: flex;
  flex-direction: column;
  color: ${props => props.theme.secondaryColor};
  & > span[class^="metric-number__"] {
    color: ${props => props.theme.bodyColor};
    font-size: 36px;
    ${props => props.primary && `
      font-size: 48px;
    `};
    line-height: 120%;
  }

  margin-right: 0 2px;
  &:first-child {
    margin-left: 0;
  }
  &:last-child {
    margin-right: 0;
  }
`;

const Type = styled.span`
  text-transform: uppercase;
  font-size: 14px;
  ${props => props.primary && `
    font-size: 16px;
  `};
  font-weight: ${props => props.theme.fontWeightHeavy};
  line-height: 16px;
  letter-spacing: 0.1px;
  color: ${props => props.theme.secondaryColor};
`;

export default function Stat({ type, number, primary }) {
  return (
    <Tile primary={primary}>
      <Type primary={primary}>{type}</Type>
      <MetricNumber n={number} />
    </Tile>
  );
}

Stat.propTypes = {
  type: PropTypes.string.isRequired,
  number: PropTypes.number.isRequired,
  primary: PropTypes.bool,
};

Stat.defaultProps = {
  primary: false,
};
